import { render } from "./GdaCentersKpiPanel.vue?vue&type=template&id=bc67a2b6&scoped=true&ts=true"
import script from "./GdaCentersKpiPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GdaCentersKpiPanel.vue?vue&type=script&setup=true&lang=ts"

import "./GdaCentersKpiPanel.vue?vue&type=style&index=0&id=bc67a2b6&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc67a2b6"],['__file',"resources/js/views/home/components/gda-centers-kpi/GdaCentersKpiPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc67a2b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc67a2b6', __exports__)) {
    console.log('reload')
    api.reload('bc67a2b6', __exports__)
  }
  
  module.hot.accept("./GdaCentersKpiPanel.vue?vue&type=template&id=bc67a2b6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('bc67a2b6', render)
  })

}


export default __exports__